


















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Lazyload } from 'vant';
import { getUserList } from '../api';
import { Image as VanImage } from 'vant';

Vue.use(List).use(Lazyload);
@Component
export default class User extends Vue {
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  inputText: string = '';
  to: string = '';
  from: string = '';
  next: string = '';
  List: any[] = [];
  onLoad() {
    getUserList(this.page, window.localStorage.getItem('unionid')).then(
      (res: any) => {
        console.log('resssssss:', res);
        this.endListData(res);
      },
    );
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.List = [...this.List, ...res.data];
    }
    this.loading = false;
  }
  goDetail(id: string) {
    this.$router.push(`detail?id=${id}`);
  }
}
